export default function leftPad(padVal, padChar, amount) {
  padVal = `${padVal}`;
  if(padVal.length < amount) {
    padVal = new Array(amount - padVal.length).fill(padChar).concat(padVal).join('');
  }
  return padVal;
}



// WEBPACK FOOTER //
// ./shared/lib/leftPad.js